import { render, staticRenderFns } from "./RubroPage.vue?vue&type=template&id=421ce9c3"
import script from "./RubroPage.js?vue&type=script&lang=js&external"
export * from "./RubroPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports